const Moment = require('moment/min/moment-with-locales.min.js');

const appLanguageInStorage = localStorage.getItem('appLanguage');

Moment.locale(appLanguageInStorage || "en");
export default Moment;
